import { useContext } from 'react';
import AuthContext from '../contexts/RealmAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
